import React, { useEffect, useState } from "react";
import "../styles/HomePage.scss";

const dummyData = [
  { symbol: "BTCUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "3.08", volume: "2345.340", accuracy: 70 },
  { symbol: "ETHUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "2.85", volume: "2345.340", accuracy: -70 },
  { symbol: "DOGEUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "13.33", volume: "2345.340", accuracy: -70 },
  { symbol: "BTCUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "3.08", volume: "2345.340", accuracy: 70 },
  { symbol: "ETHUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "2.85", volume: "2345.340", accuracy: -70 },
  { symbol: "DOGEUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "13.33", volume: "2345.340", accuracy: -70 },
  { symbol: "BTCUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "3.08", volume: "2345.340", accuracy: 70 },
  { symbol: "ETHUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "2.85", volume: "2345.340", accuracy: -70 },
  { symbol: "DOGEUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "13.33", volume: "2345.340", accuracy: -70 },
  { symbol: "BTCUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "3.08", volume: "2345.340", accuracy: 70 },
  { symbol: "ETHUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "2.85", volume: "2345.340", accuracy: -70 },
  { symbol: "DOGEUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "13.33", volume: "2345.340", accuracy: -70 },
  { symbol: "BTCUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "3.08", volume: "2345.340", accuracy: 70 },
  { symbol: "ETHUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "2.85", volume: "2345.340", accuracy: -70 },
  { symbol: "DOGEUSDT", open: 2345.340, estHigh: 2345.340, high: 2345.340, estLow: 2345.340, low: 2345.340, close: 2345.340, currentPrice: 2345.340, highGain: "13.33", volume: "2345.340", accuracy: -70 },
];

const HomePage = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let value = 0;
    const interval = setInterval(() => {
      value++;
      setProgress(value);
      if (value >= 100) clearInterval(interval);
    }, 15);
    return () => clearInterval(interval);
  }, []);
  const [rowProgress, setRowProgress] = useState(Array(dummyData.length).fill(1));

  useEffect(() => {
    const intervals = dummyData.map((_, i) => {
      let value = 1;
      return setInterval(() => {
        setRowProgress(prev => {
          const updated = [...prev];
          updated[i] = value;
          return updated;
        });
        value++;
        if (value > 99) clearInterval(intervals[i]);
      }, 20);
    });
    return () => intervals.forEach(clearInterval);
  }, []);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const sortedData = React.useMemo(() => {
      let sortableItems = [...dummyData];
      if (sortConfig.key !== null) {
        sortableItems.sort((a, b) => {
          if (sortConfig.key === "rh") {
            const aRH = ["BTCUSDT", "ETHUSDT"].includes(a.symbol) ? 1 : 0;
            const bRH = ["BTCUSDT", "ETHUSDT"].includes(b.symbol) ? 1 : 0;
            return sortConfig.direction === "asc" ? aRH - bRH : bRH - aRH;
          }
          if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "asc" ? -1 : 1;
          if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "asc" ? 1 : -1;
          return 0;
        });
      }
      return sortableItems;
    }, [sortConfig]);

    const requestSort = (key) => {
      let direction = "asc";
      if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
      }
      setSortConfig({ key, direction });
    };




  return (
    <div className="table-container">
      <div className="filter-topbar">
        <button className="liveMarket active" type="button">
          Locomotiv ~ Ai Engine
        </button>
        <img
          className="filter-separator"
          src="https://cdn-eu.icons8.com/docs/V443pG6c4020pcGKhAhMcg/fcxRd1SSekaYK--CZcD2CA.svg"
          alt="separator"
          width={24}
          height={36}
          aria-hidden="true"
          draggable={false}
        />
        <button className="robinhood" type="button" title="Show only Robinhood coins">
          <img
            src="/dollar.png"
            alt="RH"
            className="filter-icon"
            width={24}
            height={45}
            draggable={false}
          />
        </button>
        <img
          className="filter-separator"
          src="https://cdn-eu.icons8.com/docs/V443pG6c4020pcGKhAhMcg/fcxRd1SSekaYK--CZcD2CA.svg"
          alt="separator"
          width={24}
          height={36}
          aria-hidden="true"
          draggable={false}
        />
        <button className="highGains" type="button" title="Show only high gainers">
          <img
            src="/shutdown.png"
            alt="High Gains"
            className="poweroff-icon"
            width={47}
            height={45}
            draggable={false}
          />
        </button>
        <div className="timeupdated">last updated 12:00 PM</div>
        <div className="ailiveEngine">
          <img src="/enginelive.png" alt="" />
        </div>
        <span className="status">Ai Engine <br />Live</span>

      </div>

      <div className="main-header">
        <div className="allcoins">Coin Model</div>
      </div>

      <div className="header">
        <div className="controls-container">
          <div className="dateSelection">
            <button type="button" className="custom-date-input">
              <img width="40" height="40" src="https://lcdn-eu.icons8.com/c/V443pG6c4020pcGKhAhMcg/fb8befafe83891e6c72630736692d49fd2ae0d8c.png" />
              <span style={{ fontWeight: 600, color: "#000", marginLeft: 10 }}>
                July 15th, 2025
              </span>
            </button>
          </div>
        </div>
      </div>
      
      <div className="progress">
        <div className="icon">
          <svg width="80" height="80" viewBox="0 0 80 80" style={{ transform: "rotate(-90deg)" }}>
            
            <defs>
              <clipPath id="circle-clip">
                <circle cx="40" cy="40" r="36" />
              </clipPath>
            </defs>

            <image
              href="/ovel.png"
              x="0"
              y="0"
              width="80"
              height="80"
              clipPath="url(#circle-clip)"
              preserveAspectRatio="xMidYMid slice"
            />

            <circle
              cx="40"
              cy="40"
              r="39"
              stroke="#D9D9D2"
              strokeWidth="10"
              fill="none"
            />
 
            <circle
              cx="40"
              cy="40"
              r="35"
              stroke="#08B189"
              strokeWidth="10"
              fill="none"
              strokeDasharray={2 * Math.PI * 35}
              strokeDashoffset={2 * Math.PI * 35 * (1 - progress / 100)}
              style={{
                transition: "stroke-dashoffset 0.15s linear"
              }}
            />
          </svg>

          <span className="progress-label">
            <img src="/light.png" alt="" />
          </span>
        </div>

        <div className="progress-text">
          Status: in Progress
          <div className="percentage">{progress}%</div>
        </div>

        <div className="line3">
          <img src="/line3.png" alt="" />
        </div>

        <div className="startTime">
          Start Time
          <div className="time">12:02 am</div>
        </div>

        <div className="line4">
          <img src="/line4.png" alt="" />
        </div>

        <div className="finishTime">
          Finish Time
          <div className="time">12:05 pm</div>
        </div>
      </div>

      <div className="crypto-table-wrapper">
          <table className="crypto-table">
          <thead>
            <tr>
              <th className="noH">No.</th>
              <th className="coinRowH">COIN</th>
              <th className="stH">START TIME</th>
              <th className="tpH">TRAINING PROGRESS</th>
              <th className="ftH">FINISH TIME</th>
              <th className="mH">MAPE</th>
              <th className="smH">SMAPE</th>
              <th className="rmsH">RMSE</th>
              <th className="statusH">STATUS</th>
            </tr>
          </thead>
        </table>
        <div className="table-scroll">
          <table className="crypto-table">
            <tbody>
            {sortedData.map((item, index) => (
              <tr key={item.symbol}>
                <td className="noD">
                  {index + 1}
                </td>
                <td className="coinRowD">
                  <div className="coin-cell">
                    <img
                      className="coin-logo"
                      src="/generic.png"
                      alt={item.symbol}
                      loading="lazy"
                    />
                    <span className="coin-name"> {item.symbol}</span>
                  </div>
                </td>
                <td className="stD">
                  12:30 am
                </td>
                <td className="tpD">
                  <div className="progress-bar-row">
                    <div className="progress-bar-container">
                      <div
                        className="progress-bar"
                        style={{ width: `${rowProgress[index]}%` }}
                      />
                    </div>
                    <span className="progress-bar-label">{rowProgress[index]}%</span>
                  </div>
                </td>
                <td className="ftD">09:30 am</td>
                <td className="mD">1.2%</td>
                <td className="smD">1.2%</td>
                <td className="rmsD">1.2%</td>
                <td className="statusD">Completed</td>
                
              </tr>
            ))}
          </tbody>
          </table>
        </div>
      </div>
      

         <div className="estimate">
          Estimates
         </div>
      <table className="estimate-table">
        <thead>
          <tr>
            <th className="enoH">No.</th>
            <th className="ecoinRowH" onClick={() => requestSort('symbol')} style={{ cursor: 'pointer' }}>
              COIN
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'symbol' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="rh-columnH" onClick={() => requestSort('rh')} style={{ cursor: 'pointer' }}>
              RH
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'rh' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="eopenH">EST. OPEN</th>
            <th className="eopenH">OPEN</th>
            <th className="ehighH" onClick={() => requestSort('estHigh')} style={{ cursor: 'pointer' }}>
              EST. HIGH
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'estHigh' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="ehighH" onClick={() => requestSort('high')} style={{ cursor: 'pointer' }}>
              HIGH
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'high' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="elowH" onClick={() => requestSort('estLow')} style={{ cursor: 'pointer' }}>
              EST. LOW
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'estLow' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="elowH" onClick={() => requestSort('low')} style={{ cursor: 'pointer' }}>
              LOW
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'low' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
            <th className="ecloseH">EST. CLOSE</th>
            <th className="ecloseH">CLOSE</th>
            <th className="accuracyH" onClick={() => requestSort('accuracy')} style={{ cursor: 'pointer' }}>
              ACCURACY
              <span style={{ display: "inline-block", width: 16, textAlign: "center" }}>
                {sortConfig.key === 'accuracy' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={item.symbol + index}>
              <td className="enoD">
                <span className="enoD-number">{index + 1}</span>
              </td>
              <td className="ecoinRowD">
                <div className="coin-cell">
                  <img
                    className="coin-logo"
                    src="/generic.png"
                    alt={item.symbol}
                    loading="lazy"
                  />
                  <span className="coin-name">{item.symbol}</span>
                </div>
              </td>
              <td className="rh-columnD">
                {["BTCUSDT", "ETHUSDT"].includes(item.symbol) ? (
                  <img src="/rh.svg" alt="RH" loading="lazy" />
                ) : (
                  ""
                )}
              </td>
              <td className="eopenD">{item.estOpen || "$2345.340"}</td>
              <td className="eopenD">${item.open}</td>
              <td className="ehighD">${item.estHigh}</td>
              <td className="ehighD">${item.high}</td>
              <td className="elowD">${item.estLow}</td>
              <td className="elowD">${item.low}</td>
              <td className="ecloseD">{item.estClose || "$2345.340"}</td>
              <td className="ecloseD">${item.close}</td>
              <td className="accuracyD">
                <div className={`accuracy-bar ${item.accuracy > 0 ? "positive" : "negative"}`}>
                  {item.accuracy} @
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="space"></div>
    </div>
  );
};

export default HomePage;